/* Riposte — panier.
   Le formulaire fonctionne entièrement sans ce script : les quantités se
   valident par le bouton « Mettre à jour », et « Retirer » est un lien.
   Le script ne fait que supprimer une étape. */
(function () {
  'use strict';

  var root = document.querySelector('[data-rpc]');
  if (!root) return;

  var form = root.querySelector('[data-rpc-form]');
  var update = root.querySelector('[data-rpc-update]');
  if (!form) return;

  // Le bouton de repli n'a plus lieu d'être puisque le script est là.
  if (update) update.hidden = true;

  root.querySelectorAll('[data-rpc-qty]').forEach(function (input) {
    var before = input.value;

    input.addEventListener('change', function () {
      // Une quantité inchangée ne doit pas recharger la page.
      if (input.value === before) return;
      if (input.value === '' || Number(input.value) < 0) {
        input.value = before;
        return;
      }
      form.submit();
    });

    // Entrée dans un champ nombre soumettrait le formulaire avec le
    // bouton par défaut, qui est « Passer commande ». On intercepte.
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      input.blur();
    });
  });
})();
